import axios from '@axios'
import Form from '@/libs/vForm'
import store from '@/store'
const auth = store.state.auth.userData
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    saveWaslData(ctx,data){

      return new Promise((resolve,reject)=>{
        axios.post('wasl',data)
        .then(res=>{
          resolve(res)
          ctx.state.data.wasl = true
          if(data.type=="companyDelete"){ ctx.state.data.wasl = false}
        }).catch(error=>reject(error))
      })
    },

    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('users', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getManagers(ctx, params) {
      return new Promise((resolve, reject) => {
        axios.get(`userGetLinked`, { params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getContracts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios.get(`userGetLinked`, { params})
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },

    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`users/${id}`)
          .then(response => {
            resolve(response)
           
            ctx.state.data=response.data
          })
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios.post('users', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editUser(ctx, form) {

     // console.log(form)
      return new Promise((resolve, reject) => {
        axios.put(`users/${form.id}`, form)

          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setWaslData(ctx,form){
    
      //console.log('form data is',form)
      let data={}
      let postedData={
        
        "type":"company_registration",
        "user_id":form.id,
        "wasl_data":{
          "activity":"DEFAULT",
          "identityNumber":form.identityNumber,
          "commercialRecordNumber":form.commercialRecordNumber,
          "commercialRecordIssueDateHijri":form.commercialRecordIssueDateHijri,
          "phoneNumber":form.phoneNumber,
          //"extensionNumber":form.extensionNumber,
          "extensionNumber":"1234587888",
          "emailAddress":form.emailAddress,
          "managerName":form.managerName,
          "managerPhoneNumber":form.managerPhoneNumber,
          "managerMobileNumber":form.managerMobileNumber,
        }
      }

      let putData={
       
        "type":"company_update",
        "user_id":form.id,
        "wasl_data":{
           "activity":"DEFAULT",
          "identityNumber":form.identityNumber,
          "commercialRecordNumber":form.commercialRecordNumber,
          
          "managerName":form.managerName,
          "managerPhoneNumber":form.managerPhoneNumber,
          "managerMobileNumber":form.managerMobileNumber,
        }
      }

      if(form.wasl==false){
       Object.assign(data,postedData)
      // data=postedData
      }else{
        Object.assign(data,putData)
      }

      

      
   // console.log('wasl infromation ...',data)
  
      return new Promise((resolve,reject)=>{
  
       axios.post('wasl',data)
       .then(response => resolve(response))
      .catch(error =>{
       
        reject(error)
      })
  
    })
  }
}
}
